import React from 'react'
import PropTypes from 'prop-types'
import { SettingOutlined, FileTextOutlined, PlayCircleOutlined } from '@ant-design/icons';
import { Breadcrumb, Divider, Button } from 'antd';
import styles from './Component.css'

export default class _Header_ extends React.PureComponent {

  static propTypes = {
    onClickManageDocuments: PropTypes.func.isRequired,
    onClickSettings: PropTypes.func.isRequired,
    onClickRunNow: PropTypes.func.isRequired,
    isRunning: PropTypes.bool,
  }

  render () {

    const {
      onClickManageDocuments,
      onClickSettings,
      onClickRunNow,
      isRunning = false,
    } = this.props

    return (
      <div className={styles.wrapper}>

        <div className={styles.breadcrumbs}>

          <Breadcrumb separator="»">

            <Breadcrumb.Item>
              Home
            </Breadcrumb.Item>

            <Breadcrumb.Item>
              Tool Box Talks
            </Breadcrumb.Item>

          </Breadcrumb>

        </div>

        <Divider />

        <div class="_header_bar">

          <h1>
            Tool Box Talks
          </h1>

          <Button onClick={onClickManageDocuments} style={{ marginRight: 8 }}>
            <FileTextOutlined style={{ fontSize: 16, marginTop: 3 }} />
            Manage Documents
          </Button>

          <Button onClick={onClickSettings} style={{ marginRight: 8 }}>
            <SettingOutlined style={{ fontSize: 16, marginTop: 3 }} />
            Settings
          </Button>

          <Button 
            type="primary" 
            onClick={onClickRunNow}
            loading={isRunning}
            disabled={isRunning}
          >
            <PlayCircleOutlined style={{ fontSize: 16, marginTop: 3 }} />
            {isRunning ? 'Running...' : 'Run Now'}
          </Button>

        </div>

      </div>
    );
  }
}
